// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:16:48

export default {
  "id": "stickman-troll-thief-puzzle-1",
  "slug": "stickman-troll-thief-puzzle-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/48b445f207da4ac28fd1f42fb1deb89f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/48b445f207da4ac28fd1f42fb1deb89f/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stickman Troll Thief Puzzle",
      "description": "Thief Puzzle is a funny and addictive casual puzzle game. Here you should help a clever stickman with many funny ways to solve puzzles and steal target items. The rich and varied game scene contains many unexpected obstacles and traps, testing your intelligence and logical thinking. Each level of the game is a unique challenge. To make flexible movements of the character to overcome obstacles, avoid enemies, and successfully steal the target item. ",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "棍人巨魔盗贼解谜游戏",
      "description": "Thief Puzzle 是一款有趣且上瘾的休闲解谜游戏。在这里，你需要帮助一个聪明的棒形小人通过许多有趣的方式解决谜题并偷取目标物品。丰富的多变游戏场景包含许多意想不到的障碍和陷阱，考验你的智慧和逻辑思维。游戏的每个关卡都是一项独特的挑战。为了使角色灵活移动以克服障碍、避开敌人并成功偷取目标物品。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "棍人"
      ]
    },
    "zh-TW": {
      "title": "棍人巨魔盜賊拼圖",
      "description": "Thief Puzzle 是一款有趣且上癮的休闲解謎遊戲。這裡你需要幫助一位機智的木人，以許多有趣的方式解謎並偷取目標物品。豐富多樣的遊戲場景包含了許多意外的障礙和陷阱，挑戰你的智慧與邏輯思考。遊戲的每個關卡都是一個獨特的挑戰。為了讓角色能夠靈活移動以克服障礙，避開敵人，並成功偷取目標物品。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "棍人"
      ]
    },
    "zh-HK": {
      "title": "棍人巨魔盜賊謎題",
      "description": "Thief Puzzle 嘅個搞笑又上癮嘅輕鬆益智遊戲。喺呢度，你應該幫一個機靈嘅木人用多種搞笑嘅方法解謎同偷取目標物品。遊戲場景豐富多樣，充滿咁多意外嘅障礙同陷阱，考驗你嘅智慧同邏輯思考。遊戲每個關卡都係一個獨特嘅挑戰。為咗令角色可以靈活移動，克服障礙，避開敵人，並成功偷取目標物品。",
      "instructions": "用鼠標點擊或觸控玩遊戲",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "木人仔"
      ]
    },
    "ja": {
      "title": "ストックマントロル泥棒パズル",
      "description": "Thief Puzzleは面白くて魅力的なパズルゲームです。ここでは、賢いスティックマンが様々な面白い方法でパズルを解決し、ターゲットアイテムを盗む手助けをします。豊富で多様なゲームシーンには多くの予想外の障害と罠があり、あなたの知能と論理的な思考を試します。ゲームの各レベルはユニークな挑戦です。キャラクターを柔軟に動かして障害を乗り越え、敵を避け、ターゲットアイテムを成功裏に盗むことを目指します。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "スティックマン"
      ]
    },
    "ko": {
      "title": "스틱맨 트롤 털이 블록퓨즈",
      "description": "Thief Puzzle은 재미있고 중독성이 있는 캐주얼 퍼즐 게임입니다. 여기서는 지혜로운 스틱맨을 도와 여러 가지 흥미로운 방법으로 퍼즐을 해결하고 목표 아이템을 훔치는 것을 도와야 합니다. 다양하고 풍부한 게임 씬에는 많은 예상치 못한 장애물과 트랩이 있어서 지능과 논리적 사고를 테스트합니다. 게임의 각 레벨은 독특한 도전입니다. 장애물을 극복하고 적을 피하며 목표 아이템을 성공적으로 훔치기 위해 캐릭터의 유연한 움직임을 만들어야 합니다.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Grimpette Troll Voleur Puzzle",
      "description": "Thief Puzzle est un jeu de puzzle amusant et accrocheur. Ici, vous devez aider un stickman malin à résoudre des puzzles de multiples façons humoristiques et à dérober des objets cibles. La riche et variée scène de jeu contient de nombreux obstacles et pièges inattendus, testant votre intelligence et votre pensée logique. Chaque niveau du jeu est un défi unique. Pour permettre aux mouvements flexibles du personnage de surmonter les obstacles, d'éviter les ennemis et de dérober avec succès l'objet cible.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "stickman"
      ]
    }
  }
};
